import { Truck, AlertTriangle } from "lucide-react";
import DriversDropdown from "../inputs/DriversDropdown";
import VehiclesDropdown from "../inputs/VehiclesDropdown";

interface ResourcesSectionProps {
  formData: any;
  setFormData: (data: any) => void;
  handleDriverChange: (driverId: number | null, driverName?: string, driver?: any) => void;
  handleVehicleChange: (vehicleId: number | null, vehicle?: any) => void;
  vehicleError: string;
  driverVehicle: any;
  dropdownsData: any;
}

const ResourcesSection: React.FC<ResourcesSectionProps> = ({
  formData,
  setFormData,
  handleDriverChange,
  handleVehicleChange,
  vehicleError,
  driverVehicle,
  dropdownsData
}) => {
  return (
    <div className="bg-gradient-to-r from-slate-50 to-gray-100 rounded-xl p-4 border border-slate-200 shadow-sm">
      <div className="flex items-center mb-3">
        <div className="p-2 bg-slate-600 rounded-lg mr-3">
          <Truck className="w-4 h-4 text-white" />
        </div>
        <h3 className="font-semibold text-gray-800 text-lg">Resurse</h3>
      </div>

      {/* Vehicle Error Alert */}
      {vehicleError && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <div className="flex items-center">
            <AlertTriangle className="w-4 h-4 text-red-600 mr-2" />
            <p className="text-sm text-red-700">{vehicleError}</p>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Șofer
          </label>
          <DriversDropdown
            value={formData.sofer_id || null}
            onChange={handleDriverChange}
            placeholder="Selectează șoferul"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Vehicul
            {driverVehicle && (
              <span className="text-xs text-green-600 ml-1">(vehicul asignat)</span>
            )}
            {formData.sofer_id && !driverVehicle && (
              <span className="text-xs text-red-600 ml-1">(fără vehicul asignat)</span>
            )}
          </label>
          
          {driverVehicle ? (
            <div className="w-full px-3 py-2 border border-gray-300 rounded bg-green-50 border-green-300">
              <div className="flex items-center">
                <Truck className="w-4 h-4 text-green-600 mr-2" />
                <span className="text-sm text-green-800">
                  {driverVehicle.marca} {driverVehicle.model} - {driverVehicle.numar_inmatriculare}
                </span>
              </div>
            </div>
          ) : formData.sofer_id ? (
            <div className="w-full px-3 py-2 border border-red-300 rounded bg-red-50">
              <div className="flex items-center">
                <AlertTriangle className="w-4 h-4 text-red-600 mr-2" />
                <span className="text-sm text-red-700">
                  Vehicul indisponibil
                </span>
              </div>
            </div>
          ) : (
            <VehiclesDropdown
              value={formData.vehicul_id || null}
              onChange={handleVehicleChange}
              placeholder="Selectează vehiculul"
              vehicles={dropdownsData.vehicles}
              disabled={false}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResourcesSection;